import React from 'react';
import './PageTitle.scss';

interface PageTitleProps {
  title: string;
  description?: string | React.ReactNode;
}
export default function PageTitle({ title, description }: PageTitleProps): React.ReactElement {
  return (
    <section className="page-title">
      <h1>{title}</h1>
      {description && <p dangerouslySetInnerHTML={{ __html: description }} />}
    </section>
  );
}
